import * as React from 'react';
import { HarvardUniversityLogo } from '../HarvardUniversityLogo';
import { WrappedMessage } from 'utils';
import messages from './displayMessages';

interface FooterLayoutProps {
  children?: React.ReactNode;
  footerFeature?: React.ReactNode;
  className?: string;
}

export const FooterLayout: React.FunctionComponent<FooterLayoutProps> = ({
  children,
  footerFeature,
  className = '',
}) => {
  return (
    <>
      <div className='footer-feature'>
        {footerFeature ? footerFeature : null}
      </div>
      <footer className={className}>
        {/* Hide this section when user is on homepage */}
        {!/^\/?$/.test(window.location.pathname) && (
          <div className='footer-harvard-panel'>
            <HarvardUniversityLogo width={214} height={54} />
          </div>
        )}
        {children}
        <div className='footer-notes'>
          <WrappedMessage
            message={messages.footerCopyright}
            values={{ year: new Date().getFullYear() }}
          />
        </div>
      </footer>
    </>
  );
};
